var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopFourthCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 678,
    height: 876,
    viewBox: "0 0 678 876",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 438,
    cy: 438,
    r: 436.5,
    transform: "rotate(180 438 438)",
    fill: "white",
    fillOpacity: 0.2,
    stroke: "white",
    strokeWidth: 3,
    strokeDasharray: "12 12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopFourthCircle);
export default __webpack_public_path__ + "static/media/top-fourth-circle.711e11f66acbd6846f1ae8767e97960a.svg";
export { ForwardRef as ReactComponent };